<template>
  <div class="col-md-12">
    <div class="d-flex justify-content-between mx-10 mt-10">
      <h4>Period Duration</h4>
      <h5>No.Period {{ period.length }}</h5>
    </div>
    <div v-for="(o, index) in period" :key="o.id">
      <table class="table table-borderless">
        <tbody>
          <tr>
            <td>
              <h5>Period {{ index + 1 }}</h5>
            </td>
            <td>
              <table>
                <tr>
                  <td>Start</td>
                  <td>
                    <DatePicker
                      type="date"
                      width-200px
                      @change="update(o.id)"
                      placeholder="n/a"
                      ref="start_date"
                      format="YYYY-MM-DD"
                      value-type="YYYY-MM-DD"
                      :disabled="disabled"
                      v-model="o.start_date"
                    />
                  </td>
                  <td>End</td>
                  <td>
                    <DatePicker
                      type="date"
                      width-200px
                      @change="update(o.id)"
                      placeholder="n/a"
                      ref="end_date"
                      format="YYYY-MM-DD"
                      value-type="YYYY-MM-DD"
                      :disabled="disabled"
                      v-model="o.end_date"
                    />
                  </td>
                </tr>
                <tr></tr>
              </table>
            </td>
            <td>
              <button
                class="btn btn-default"
                :disabled="period.length <= 2 || disabled"
                type="button"
                @click="removePeriod(o.id)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div class="form-group w-450">
                <div my-15px>
                  <label class="mx-5">
                    <p class="mb-0">
                      Period Prize
                      <span class="small light">
                        (recommended size 240x240 px)
                      </span>
                    </p>
                  </label>

                  <div class="form-group">
                    <div class="d-block">
                      <img
                        class="img img-fluid image-preview"
                        v-if="o.period_picture"
                        :src="o.period_picture"
                      />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      class="form-control"
                      :data-id="o.id"
                      @change="uploadImage"
                      :disabled="disabled"
                    />
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <hr />
    </div>

    <div class="action">
      <button
        class="btn btn-default"
        :disabled="period.length >= 5 || disabled"
        @click="addPeriod"
        type="button"
      >
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { progressBarService } from "@/api/client";

const httpService = progressBarService.axiosInstance;

export default {
  name: "PeriodDuration",

  props: ["campaign"],

  components: {
    DatePicker,
  },

  data() {
    return {
      period: [],
    };
  },

  computed: {
    disabled() {
      return this.campaign.status != "draft";
    },
  },

  watch: {
    "campaign.weekly.period"() {
      this.period = this.campaign.weekly.period;
    },
  },

  methods: {
    async update(id) {
      const { start_date, end_date } = this.period.find((o) => o.id === id);

      if (start_date && end_date && new Date(start_date) > new Date(end_date)) {
        this.$dialogs.alert(`กรุณาระบุวันทีให้ถูกต้อง`);

        const oldValue = this.campaign.weekly.period.find((o) => o.id === id);

        const matchedIndex = this.period.findIndex((o) => o.id === id);
        this.period[matchedIndex] = oldValue;

        return;
      }

      try {
        await httpService.put(`/${this.campaign.id}/weekly/period/${id}`, {
          start_date,
          end_date,
        });

        this.$emit("updated");
        this.$notify(`Period date updated.`);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Update period error.`);
      }
    },

    async uploadImage(event) {
      const file = event.target.files[0];

      if (file.size > 5000000) {
        this.$notify("File shall not exceed 5 MB");
        event.target.files[0].value = "";
        return;
      }

      try {
        if (!file) return;
        const form = new FormData();
        form.append("period_picture", file);

        const { id } = this.campaign;

        const periodId = event.target.getAttribute("data-id");

        await httpService.post(`${id}/weekly/period/${periodId}/upload`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$emit("updated");
        this.$notify(`Period picture updated.`);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Upload period picture error.`);
      }
    },

    async addPeriod() {
      try {
        const { data } = await httpService.post(
          `/${this.campaign.id}/weekly/period`
        );

        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Add period error.`);
      }
    },

    async removePeriod(id) {
      try {
        //   https://gwapi-sandbox.vivi-th.com/ams/api/progressbar/<campaign id>/weekly/period/<period_id>
        const { data } = await httpService.delete(
          `/${this.campaign.id}/weekly/period/${id}`
        );

        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Remove period error.`);
      }
    },
  },

  mounted() {
    this.period = this.campaign.weekly.period;
  },
};
</script>

<style lang="scss" scoped>
.image-preview {
  max-width: 240px;
}
</style>